import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";

export const Steps = () => {
  const { t } = useLang();
  return (
    <section data-testid="steps-section" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-400">
            {t.steps.overline}
          </span>
          <h2 className="mt-4 font-outfit text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
            {t.steps.title}
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {t.steps.items.map((s, i) => {
            const num = String(i + 1).padStart(2, "0");
            return (
              <motion.div
                key={i}
                data-testid={`step-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="relative rounded-2xl border border-white/10 bg-white/[0.03] p-8"
              >
                <span className="font-outfit text-6xl font-black text-white/10">{num}</span>
                <h3 className="mt-3 font-outfit text-xl font-bold text-white">{s.title}</h3>
                <p className="mt-2 text-slate-400 leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
